<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <modal-form modal-id="add-user" animation="fadeInRight">
      <div slot="title">Add New Registrar</div>
      <div slot="form">
        <div class="form-group">
          <div class="row">
            <div class="col-lg-3">Name</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="registrarAdd['name']">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Client</div>
            <div class="col-lg-9">
              <v-select :options="user.admin ? this.f.clients : user.clients" v-model="registrarAdd['client']" label="name" index="id"></v-select>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Integration</div>
            <div class="col-lg-9">
              <v-select
                :options="Object.keys(this.f.registrarIntegrations || {})"
                v-model="registrarAdd['integration']"
                @input="updateAuthKeys($event)">
              </v-select>
            </div>
          </div>
          <div class="row" v-if="registrarAdd['integration']" v-for="integrationAuth in authKeys" :key="registrarAdd['integration'] + integrationAuth">
            <div class="col-lg-3">{{ integrationAuth | integrationAuthFriendly }}</div>
            <div class="col-lg-9">
              <input type="text" name="" class="form-control" v-model="registrarAdd.auth[integrationAuth]">
            </div>
          </div>
          <div class="row">
            <div class="col-lg-3">Auto import new domains</div>
            <div class="col-lg-9">
              <input type="checkbox" v-model="registrarAdd['autoImportDomains']">
            </div>
          </div>
          <div class="row m-t-md">
            <div class="col-lg-12">
              <button class="btn btn-sm btn-primary" @click="saveUser">Save</button>
            </div>
          </div>
        </div>
      </div>
    </modal-form>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Registrars</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-user">Add registrar</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Registrars/Filters'
import List from './Registrars/List'
import axios from 'axios'
import { REGISTRAR_LIST_SET } from '../../../store/mutation-types'
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'
import { String } from '../../../mixins/helperMixin'

// Add User Defaults
const registrarAddDefaults = {
  name: '',
  client: '',
  integration: '',
  apiKey: null,
  secretKey: null,
  auth: {}
}

export default {
  data () {
    return {
      registrarAdd: {...registrarAddDefaults},
      authKeys: []
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser'
    })
  },
  mounted () {
    document.title = 'Account Registrars :: PBN360 by Aphex Media'
    this.$store.dispatch('loadRegistrars')
    if (!this.f.clients || !this.f.registrarIntegrations) {
      this.$store.dispatch('loadFilters')
    }
  },
  mixins: [String],
  components: {
    filters: Filters,
    list: List,
    modalForm: Modal
  },
  filters: {
    integrationAuthFriendly: key => {
      switch (key) {
        case 'apiKey':
          return 'API Key'
        case 'secretKey':
          return 'API Secret'
        default:
          return String.methods.ucFirst(key)
      }
    }
  },
  methods: {
    saveUser () {
      const registrarAdd = {...this.registrarAdd}
      if (!registrarAdd.name) {
        this.$toastr.error('Please name new integration', 'Please try a bit harder')
        return
      }

      if (!this.user.admin && !this.user.clients.map(c => c.id).includes(registrarAdd.client)) {
        this.$toastr.error('Please select client', 'Please try a bit harder')
        return
      }

      if (
        registrarAdd.integration &&
        this.f.registrarIntegrations[registrarAdd.integration]['auth']
          .reduce((acc, cur) => !registrarAdd.auth[cur], false)
      ) {
        this.$toastr.error(`Credentials for ${registrarAdd.integration} are missing!`, 'Please try a bit harder')
        return
      }

      axios.post('/registrar', registrarAdd)
        .then(r => {
          $('#add-user').modal('hide')
          this.$store.commit(REGISTRAR_LIST_SET, [...this.$store.state.registrarList, r.data])
          this.$toastr.success('Registrar added successfully', 'Brilliant stuff lad')
        })
        .catch(e => {
          const msg = e.response ? e.response.data.msg : 'Not so great is it...'
          this.$toastr.error(e, msg)
        })
      // Reset form to defaults
      Object.keys(registrarAddDefaults).forEach(k => {
        this.$set(this.registrarAdd, k, registrarAddDefaults[k])
      })
      this.$forceUpdate()
    },
    updateAuthKeys (integration) {
      this.authKeys = integration ? this.f.registrarIntegrations[integration]['auth'] : []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Registrars.vue